import { render, staticRenderFns } from "./default.vue?vue&type=template&id=351a8605&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/app/components/app/header/index.vue').default,AppLazyHydrate: require('/app/components/app/LazyHydrate.vue').default,AppFooterTop: require('/app/components/app/footer/Top.vue').default,AppFooter: require('/app/components/app/footer/index.vue').default,AppLayout: require('/app/components/app/Layout.vue').default})
